export default class ScrollLinksHandler {
	static init() {
		// scroll to hash on load
		window.addEventListener('load', () => {
			if (window.location.hash === '#next') {
				window.location.hash = '';
			}
			ScrollLinksHandler.scrollToLinkHash(window.location);
		});

		ScrollLinksHandler.applyEventListenerOnSelector('a[href*="#"]');
	}

	static applyEventListenerOnSelector(selector) {
		window.addEventListener('click', (e) => {
			const link = e.target.closest(selector);
			if (link && link.hash && link.href.replace(location.href.replace(location.hash, ''), '') === link.hash) {
				e.preventDefault();
				e.stopPropagation();
				ScrollLinksHandler.scrollToLinkHash(link);
			}
		});
	}

	static scrollToLinkHash(link) {
		let targetElement;
		let extraOffset = 0;
		switch (link.hash) {
			case '#next':
				targetElement = link.closest('section').nextElementSibling;
				if(targetElement.classList.contains('neos-contentcollection')) {
					// the link was inside the header, so get the first content element
					targetElement = targetElement.firstElementChild;
				}
				break;
			case '#top':
				targetElement = document.body;
				break;
			default:
				if (link.hash && document.querySelector(link.hash)) {
					targetElement = document.querySelector(link.hash);
				}
				// if the page has a hash menu, we needs extra space for the absolute positioned el
				extraOffset = document.querySelector('.hash-menu') ? -81 : -15;
		}

		ScrollLinksHandler.scrollToElement(targetElement, extraOffset);
	}

	static scrollToElement(element, extraOffset) {
		if (!element) return;

		if(element.classList.contains('accordion__item')) {
			if(!element.classList.contains('accordion__item--is-active')) {
				element.querySelector('.accordion__item-heading').click();
			}
			element = element.closest('.accordion');
		}

        let offsetTop = element.offsetTop;
        if(element.classList.contains('timeline-card')) {
            offsetTop += element.closest('.timeline').offsetTop;
        }

		const header = document.querySelector('.header__inner');
        // This should not happen in production, however in Monocle we don't have a header
        // and this fallback prevents an error
        if (!header) {
            return;
        }
		window.scrollTo({
			behavior: 'smooth',
			left: 0,
			top: offsetTop - header.getBoundingClientRect().height + (extraOffset || 0)
		});
	}
}
